import { NgOptimizedImage } from "@angular/common";
import { Component, inject } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { LanguageService } from "../../../services";
import { SpinnerComponent } from "../../spinner/spinner";

@Component({
  selector: "adaa-auth-layout",
  templateUrl: "./auth-layout.html",
  styleUrl: "./auth-layout.scss",
  imports: [NgOptimizedImage, TranslatePipe, SpinnerComponent],
})
export class AuthLayoutComponent {
  languageService = inject(LanguageService);
}
